import MaterialTable from '@material-table/core';
import { Typography } from '@mui/material';
import Paper from '@mui/material/Paper';

function BearerboxStoreTable({storeStatus}) {
  const { messages } = storeStatus;

  const rows = messages.map(msg => ({
    id: msg.msgId,
    ...msg,
  }));

  return (
    <MaterialTable
      title={
        <Typography component="span" color="textSecondary" gutterBottom>
          <Typography component="span" variant="h5">
            Store Status{" "}
          </Typography>
        </Typography>
      }
      data={rows}
      columns={[
        { title: "SMS ID", field: "msgId" },
        { title: "Type", field: "type" },
        { title: "Time", field: "time" },
        { title: "Sender", field: "sender" },
        { title: "Receiver", field: "receiver" },
        { title: "SMSC ID", field: "smscId" },
        { title: "BOX ID", field: "boxId" },
        { title: "Flags", field: "flags" },
        { title: "UDH", field: "udhData" },
        { title: "Message", field: "msgData" },
      ]}
      options={{
        selection: false,
        pageSizeOptions: [10, 50],
        pageSize: 10,
        cellStyle: { whiteSpace: 'noWrap' },
      }}
      components={{
        Container: props => <Paper elevation={0} {...props} />
      }}
    />
  );
}

export default BearerboxStoreTable;
